export const BRAND_NAME = 'BaaziFair';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'baazifair.com';
export const PROVIDER_ID = 'BetFair';
